import React from 'react';
import { X, Trash2, ShoppingBag } from 'lucide-react';
import { useFavorites } from '../context/FavoritesContext';
import { useCart } from '../context/CartContext';
import { useSettings } from '../context/SettingsContext';
import { useNavigate } from 'react-router-dom';
import './FavoritesSidebar.css';
import './CartSidebar.css'; // Reuse item styles

const FavoritesSidebar = () => {
    const {
        isFavoritesOpen,
        setIsFavoritesOpen,
        favorites,
        removeFavorite
    } = useFavorites();

    const { addToCart } = useCart();
    const { settings } = useSettings();
    const navigate = useNavigate();

    const handleClose = () => setIsFavoritesOpen(false);

    return (
        <>
            <div
                className={`favorites-sidebar-overlay ${isFavoritesOpen ? 'open' : ''}`}
                onClick={handleClose}
            ></div>
            <div className={`favorites-sidebar ${isFavoritesOpen ? 'open' : ''}`}>
                <div className="favorites-header">
                    <h2>Vos Favoris</h2>
                    <button className="close-cart-btn" onClick={handleClose}>
                        <X size={24} />
                    </button>
                </div>

                <div className="cart-items">
                    {favorites.length === 0 ? (
                        <div className="empty-cart-message">
                            <p>Aucun coup de cœur pour le moment.</p>
                            <button
                                className="btn"
                                style={{ marginTop: '20px', padding: '10px 20px', fontSize: '0.9rem' }}
                                onClick={() => {
                                    handleClose();
                                    navigate('/gateaux');
                                }}
                            >
                                Explorer la carte
                            </button>
                        </div>
                    ) : (
                        favorites.map((item) => (
                            <div key={item.id} className="cart-item">
                                {item.image ? (
                                    <img src={item.image} alt={item.name} className="cart-item-image" />
                                ) : (
                                    <div className="cart-item-image" style={{ background: '#eee', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        No img
                                    </div>
                                )}
                                <div className="cart-item-details">
                                    <span className="cart-item-title">{item.name}</span>
                                    <span className="cart-item-price">{item.prix ? `${item.prix} €` : 'Prix sur demande'}</span>

                                    <div className="cart-item-controls" style={{ marginTop: '15px' }}>
                                        {!settings.isClickCollectDisabled && (
                                            <button
                                                className="btn"
                                                onClick={() => {
                                                    addToCart(item);
                                                    handleClose(); // Optional: close favs when adding to cart? Or keep open. Let's close to show cart opening.
                                                }}
                                                style={{ padding: '5px 10px', fontSize: '0.8rem', display: 'flex', alignItems: 'center', gap: '5px' }}
                                            >
                                                <ShoppingBag size={14} /> Ajouter
                                            </button>
                                        )}

                                        <button
                                            className="remove-btn"
                                            onClick={() => removeFavorite(item.id)}
                                        >
                                            <Trash2 size={16} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </>
    );
};

export default FavoritesSidebar;
